import { UNKNOWN } from '../constants';

export const isUnknown = (value: any): boolean => value === UNKNOWN;
